import React from 'react';
import Header from '../Header/Header';

const NotFound = () => {
    return (
        <div>
            <Header></Header>
            <h1>Not found</h1>
        </div>
    );
};

export default NotFound;